import styled from 'styled-components';
import { ThemeColours } from '../../../../../styles/ThemeColours';
import { FONT_STACK, FontWeight } from '../../../../../styles/constants';

export const SuggestionIcon = styled.div`
  color: ${ThemeColours.mono600};
  height: 24px;
  margin-top: 4px;
  width: 24px;
`;

export const Text = styled.span`
  ${FONT_STACK}
`;

export const SuggestionPrimary = styled(Text)`
  color: ${ThemeColours.black};
  font-size: 16px;
  font-weight: ${FontWeight.SEMI_BOLD};
`;

export const SuggestionPrimaryLight = styled(Text)`
  color: ${ThemeColours.mono600};
  font-size: 16px;
`;

export const SuggestionSecondary = styled(Text)`
  color: ${ThemeColours.mono600};
  font-size: 14px;
`;
